import axios from "axios";
const env = import.meta.env.VITE_APP_API_BASE_URL
const axiosInstance = axios.create({
  baseURL: env, 
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("BearerToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) =>{
    Promise.reject(error)
  }
);
// Response Interceptor
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("BearerToken"); // Remove token
      if(!window.location.pathname.includes('login'))
     window.location.href='/login'
    }
    return Promise.reject(error);
  }
);
export default axiosInstance;
